import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem , Autocomplete, Typography} from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useStoreStore } from "../../../hooks/useStoreStore";
import { useSaleChannelStore } from "../../../hooks/useSaleChannelStore";
import moment from "moment";
import { useSupplierStore } from "../../../hooks/useSupplierStore";

type Values = {
    id: number,
    idclient: number,
    idseller: number,
    relationship_date: string,
    goal: string,
    description: string,
    status: string,
}

const dataClients = [
    {id:1, name:'toyota Mega Store'},
    {id:2, name:'distrihbuidora Luoisa'},
]

export const ClientWalletModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, clientSelected, listClients, clearState, sellerSelected } = props;

    const { action, createStore, editStore } = useStoreStore();
    const { getSuppliers, getSuppliersByCompany } = useSupplierStore();

    const currentdate = moment().format('YYYY-MM-DD');

    const [loading, setLoading] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);
    const [clients, setClients] = useState<any>([]);
    const [selected, setSelected] = useState<any>('');
    const [data, setData] = useState<Values>({
        id: clientSelected ? clientSelected.id :'',
        idclient: clientSelected ? clientSelected.idclient :'',
        idseller: clientSelected ? clientSelected.idseller : sellerSelected.id,
        relationship_date: clientSelected ? clientSelected.relationship_date : currentdate,
        goal: clientSelected ? clientSelected.goal :'',
        description: clientSelected ? clientSelected.description :'',
        status: clientSelected ? clientSelected.status :'',
    });

    useEffect(() => {
        getSuppliersApi()
    },[])

    useEffect(() => {
        if(clientSelected && clients){
            setCustomClients(clientSelected.idclient, clients)
        }
    },[clientSelected, clients])

    const setCustomClients = (idclient, clients) => {
        const data = clients.find(branch => branch.id == idclient);
        return setSelected(data);
    }

    const getSuppliersApi = async(search='') => {
        try {
            setLoadingdata(true);
            // const response = await getSuppliersByCompany(search);
            const response = dataClients;
            if(!response){
                setClients([]);
                setLoadingdata(false);
                return false;
            }else{
                setClients(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.idclient) errors.idclient = "el campo es requerido";
        if(!values.idseller) errors.idseller = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        if(clientSelected){
            const response:any = await editStore(clientSelected.id, values);
            if(response){
                listClients && listClients();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createStore(values);
            if(response){
                listClients && listClients();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar cliente' : (action == 'add' ? 'Nuevo cliente' : 'Detalle del cliente')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                    <Grid item xs={12}>
                                            <FormLabel>Fecha de asignación:</FormLabel>
                                            <Typography sx={{paddingLeft:'15px'}}>{currentdate}</Typography>
                                            {/* <TextField
                                                id="date"
                                                type="date" 
                                                name="date"
                                                fullWidth
                                                size="small"
                                                value={currentdate}
                                                inputProps={{ readOnly:  true}}
                                            /> */}
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Vendedor:</FormLabel>
                                            <TextField
                                                id="seller"
                                                type="text" 
                                                name="rut"
                                                fullWidth
                                                size="small"
                                                value={sellerSelected?.name}
                                                onChange={handleChange}
                                                inputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Cliente:</FormLabel>
                                            <Autocomplete
                                                id="idclient"
                                                size="small"
                                                value={!!selected ? selected : null}
                                                options={clients || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small" 
                                                        error={errors.idclient && touched.idclient ? true : false}
                                                        helperText={errors.idclient && touched.idclient ? errors.idclient : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setSelected(newValue)
                                                    setFieldValue('idclient', newValue ? newValue.id : "");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Meta por mes:</FormLabel>
                                            <TextField
                                                id="goal"
                                                type="number" 
                                                name="goal"
                                                fullWidth
                                                size="small"
                                                value={values.goal}
                                                onChange={handleChange}
                                                error={errors.goal && touched.goal ? true : false}
                                                helperText={errors.goal && touched.goal ? errors.goal : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Descriptión:</FormLabel>
                                            <TextField
                                                id="description"
                                                type="text" 
                                                name="description"
                                                fullWidth
                                                size="small"
                                                value={values.description}
                                                onChange={handleChange}
                                                error={errors.description && touched.description ? true : false}
                                                helperText={errors.description && touched.description ? errors.description : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}